<template>
  <el-card>
    <div slot="header">
      <h1>{{isEdit ? '编辑': '创建'}}内购活动</h1>
    </div>
    <div class="form-container">
      <el-form v-loading="loading" ref="form" :model="form" :rules="rules" label-width="180px">
        <div class="form-group-header">基本信息</div>
        <el-form-item label="活动名称" prop="activityName">
          <el-col :span="10">
            <el-input v-model="form.activityName" />
          </el-col>
        </el-form-item>
        <el-form-item label="活动时间" required>
          <el-col :span="10">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model.sync="form.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
          </el-col>
        </el-form-item>
        <el-form-item label="内购细则" prop="detail">
          <el-col :span="10">
            <MarkdownEditor ref="markdownEditor" v-model="form.detail" :options="{ toolbarItems: [['heading','bold','italic']]}" />
          </el-col>
        </el-form-item>

        <el-form-item label="列表广告" prop="activityName">
          <el-col :span="3">
            <img :src="form.bannerUrl" alt="" v-if="form.bannerUrl">
            <el-upload :action="action" :limit="2" :headers="header" :show-file-list="false" :on-success="handleSuccess">
              <div style="text-align: left">
                <el-button size="small" type="primary">点击上传</el-button>
              </div>
              <div slot="tip" class="el-upload__tip">建议上传图片大小1100*310</div>
            </el-upload>
          </el-col>
        </el-form-item>
        <el-form-item label="售罄商品显示">
          <el-radio-group v-model="form.showSellOut">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="form-group-header">权限控制</div>
        <el-form-item label="登录方式" prop="loginMethod">
          <el-col :span="10">
            <el-checkbox-group v-model="form.loginMethod" @input="handleLoginMethodChange">
              <el-checkbox label="email">企业邮箱登录</el-checkbox>
              <el-checkbox label="mobile">手机号登陆</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-form-item>
        <el-form-item label="关联公司" prop="companies">
          <el-col :span="10">
            <el-select v-model="form.companies" multiple filterable placeholder="请选择">
              <el-option v-for="item in supportCompanies" :key="item.id" :label="item.emailSuffix ? `${item.name}(${item.emailSuffix})` : item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="登录白名单" prop="mailbox">
          <el-col :span="10">
            <el-input type="textarea" :rows="2" v-model="form.mailbox" />
            <div>可输入手机号或邮箱，使用逗号隔开;</div>
          </el-col>
        </el-form-item>
        <el-form-item label="限购白名单" prop="excludeMembers">
          <el-col :span="10">
            <el-input type="textarea" :rows="2" v-model="form.excludeMembers" />
            <div>可输入手机号或邮箱，使用逗号隔开;</div>
          </el-col>
        </el-form-item>

        <div class="form-group-header">订单设置</div>
        <el-form-item label="配送方式" prop="deliveries">
          <el-col :span="10">
            <el-checkbox-group v-model="form.deliveries">
              <el-checkbox label="express">快递配送</el-checkbox>
            </el-checkbox-group>
            <el-form-item label="每单加收" v-if="selectedExpress" label-width="68px">
              <el-input v-model="form.deliveryConfigs.express.plusFee" style="width: 120px" /> 元
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="订单自动关闭时间" prop="cancelTime">
          <el-col :span="10">
            <el-select v-model="form.cancelTime">
              <el-option v-for="(cancelTime, index) of cancelTimes" :key="index" :label="cancelTime.label" :value="cancelTime.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="自定义抬头" prop="invoiceForbidden">
          <el-col :span="10">
            <el-radio-group v-model="form.invoiceForbidden">
              <el-radio label="1">禁用</el-radio>
              <el-radio label="0">启用</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="指定收货地址">
          <el-col :span="10" class="flex">
            <el-form-item label="" prop="region" style="width:240px !important">
              <el-cascader clearable :options="regionList" placeholder="请选择地区" style="width:240px" v-model="regionArray" @change="cascaderChange" :props="{label: 'regionName', value: 'regionName'}" />
            </el-form-item>
            <el-form-item label="" prop="address" style="margin-left:10px;width:240px">
              <el-input placeholder="请输入详细地址" v-model="address" @change="addressChange" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="订单退款" prop="refundEnable">
          <el-col :span="10">
            <el-radio-group v-model="form.refundEnable">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="支持退货退款" v-if="form.refundEnable === '1'" prop="returnEnable">
          <el-col :span="10">
            <el-radio-group v-model="form.returnEnable">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item class="buttons">
          <el-col :span="10">
            <el-button type="primary" @click="submitForm">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import Upload from '@/components/Uploader/index'
import { createNamespacedHelpers } from 'vuex'
import MarkdownEditor from '@/components/MarkdownEditor'
import _ from 'lodash'
import { dateToString, stringToDate } from '@/helpers'
const { mapGetters: mapCompanyGetters } = createNamespacedHelpers('companies')
const cancelTimes = [{ label: '不限制', value: 0 }, { label: 15, value: 15 }, { label: '30', value: 30 }, { label: 60, value: 60 }]
// import { regionData } from 'element-china-area-data'

export default {
  components: { MarkdownEditor, Upload },
  data() {

    var validateAddress = (rule, value, callback) => {
      if (this.region && !this.address) {
        callback(new Error('请输入详细地址'))
      } else {
        callback()
      }
    }
    var validateRegion = (rule, value, callback) => {
      if (!this.region && this.address) {
        callback(new Error('请选择地区'))
      } else {
        callback()
      }
    }
    return {
      // regionData,
      region: '',
      regionArray: [],
      address: '',
      header: { 'Authorization': 'Bearer' + this.$store.state.auth.token },
      action: this.$config.api.baseURL + `/banner-photo-upload`,

      cancelTimes,
      isEdit: false,
      loading: false,
      form: {
        refundEnable: "0",
        returnEnable: "0",
        bannerUrl: '',
        cancelTime: 0,
        activityName: '',
        dateRange: [],
        detail: '',
        companies: [],
        loginMethod: [],
        deliveries: [],
        invoiceForbidden: '1',
        deliveryConfigs: {
          express: {
            plusFee: 0
          }
        },
        mailbox: '',
        excludeMembers: '',
        showSellOut: 1
      },
      companies: [], // 已关联的公司信息
      regionList: [],
      rules: {
        // region: { validator: validateRegion, trigger: 'blur' },
        // address: { validator: validateAddress, trigger: 'blur' },
        activityName: this.$formHelper.requiredRuleFactory('请输入活动名称，活动名称不能为空。'),
        dateRange: [{ required: true, message: '请选择活动活动时间。', trigger: 'blur' }, { type: 'array', message: '请选择活动活动时间。', trigger: 'blur' },],
        loginMethod: this.$formHelper.requiredRuleFactory('请选择登录方式，登录方式不能为空。'),
        returnEnable: this.$formHelper.requiredRuleFactory('请选择是否允许退货退款。'),
        refundEnable: this.$formHelper.requiredRuleFactory('请选择是否允许退款。'),
        companies: this.$formHelper.requiredRuleFactory('请选择关联公司，关联公司不能为空。'),
        deliveries: { type: 'array', required: true, message: '请选择至少一种配送方式。', trigger: 'change' }
      }
    }
  },
  computed: {
    selectedExpress() {
      return this.form.deliveries.includes('express')
    },
    ...mapCompanyGetters({ allCompanies: 'collection' }),
    supportCompanies() {
      const loginMethod = this.form.loginMethod
      let emailCompanies = [], mobileCompanies = []
      if (loginMethod && loginMethod.length && loginMethod.includes('email')) {
        emailCompanies = this.allCompanies.filter(company => company.enableEmail === true)
      }
      if (loginMethod && loginMethod.length && loginMethod.includes('mobile')) {
        mobileCompanies = this.allCompanies.filter(company => company.enableMobile === true)
      }
      return [...new Set([...emailCompanies, ...mobileCompanies])]
    }
  },
  methods: {
    cascaderChange(value) {
      if (value && value[0] && value[1] && value[2]) {
        this.region = `${value[0]} ${value[1]} ${value[2]}`
      } else {
        this.region = ''
      }
      console.log('this.region', this.region);
      this.$refs.form.validateField(['region', 'address'])
    },
    addressChange() {
      this.$refs.form.validateField(['region', 'address'])
    },
    handleSuccess(res, file) {
      if (res.data.url) {
        this.form.bannerUrl = res.data.url
      }
    },
    async submitForm() {
      await this.$formHelper.promisedValidate(this.$refs.form)
      this.loading = true
      const activity = _.cloneDeep(this.form)
      if (!this.form.bannerUrl) {
        this.$message.error('请上传banner')
        this.loading = false
        return
      }
      activity.bannerUrl = this.form.bannerUrl
      activity.dateFrom = dateToString(activity.dateRange[0])
      activity.dateTo = dateToString(activity.dateRange[1])
      delete activity.dateRange
      activity.loginMethod = activity.loginMethod.join(',')
      activity.invoiceForbidden = this.form.invoiceForbidden
      activity.returnEnable = Number(this.form.refundEnable) ? this.form.returnEnable : 0
      if (this.region && this.address) {
        activity.region = this.region
        activity.address = this.address
      } else {
        activity.region = ''
        activity.address = ''
      }
      activity.companies = activity.companies.map(companyId => {
        const activityCompany = this.companies.find(company => company.companyId == companyId)

        return activityCompany ? {
          id: activityCompany.id,
          companyId,
        } : {
          companyId
        }
      })

      try {
        await this.$store.dispatch(this.isEdit ? 'activities/replace' : 'activities/create', activity)
      } finally {
        this.loading = false
      }
      this.$message.success('内购活动保存成功')
      // this.$router.push({ name: 'activity-activity' })
    },

    handleLoginMethodChange(value) {
      this.form.companies = []
    },

    handleEmailTagInputConfirm() {
      let inputValue = this.emailTag.inputValue;
      if (inputValue) {
        this.form.loginMethodConfigs.email.mails.push(inputValue);
      }
      this.emailTag.inputVisible = false;
      this.emailTag.inputValue = '';
    }
  },
  async mounted() {
    this.$store.dispatch('companies/collection', { all: true })
    const { id } = this.$route.params
    if (id > 0) {
      this.isEdit = true
    }
    if (this.isEdit) {
      const { document } = await this.$store.dispatch('activities/document', id)
      this.companies = document.companies
      this.form = document
      this.form.loginMethod = this.form.loginMethod.split(',').filter(item => item !== '')
      this.form.companies = this.form.companies.map(company => company.companyId)
      this.form.invoiceForbidden = String(document.invoiceForbidden)
      this.form.returnEnable = String(this.form.returnEnable)
      this.form.refundEnable = String(this.form.refundEnable)
      if (document.address) {
        this.address = document.address
      }
      if (document.region) {
        this.regionArray = document.region.split(' ')
        this.region = document.region
      }
      this.$nextTick(() => {
        this.form = {
          ...this.form,
          dateRange: [stringToDate(this.form.dateFrom), stringToDate(this.form.dateTo)]
        }
      })
    }
    this.regionList = await this.$store.dispatch('cateTree/getRegion')
    console.log(this.form)
  }
}
</script>

<style scoped>
.el-upload {
  text-align: left !important;
}

.el-form-item--medium {
  width: 100% !important;
}

.form-group-header {
  position: relative;
  margin-left: 30px;
  color: #000;
}
.form-group-header::before {
  content: '';
  width: 3px;
  height: 18px;
  background-color: #409eff;
  position: absolute;
  top: 2px;
  left: -10px;
}
</style>
